import { isWindfallReferral } from '../../../helpers/windfallHelper';

export function tradeWindfallReferralRule() {
    if (isWindfallReferral()) {
        return Promise.resolve(true);
    }

    return Promise.resolve(false);
}
